<template>
    <div class="point">
        <div class="point-number">{{ number }}</div>
        <div class="point-text">{{ point }}</div>
    </div>
</template>

<script>
    export default {
        name: 'point',
        props: {
            number: {
                type: Number,
                required: true
            },
            point: {
                type: String,
                required: true
            }
        }
    }
</script>

<style lang="less">
    @import "~@less/font-sizes.less";

    .point {
        @ballSize: 40px;

        margin-bottom: 20px;
        flex-wrap: nowrap !important;

        .point-number {
            width: @ballSize;
            height: @ballSize;
            min-width: @ballSize;
            min-height: @ballSize;

            background: black;
            color: white;
            font-size: @ballSize * .8;
            font-family: "Titillium Web", sans-serif;
            border-radius: @ballSize / 2;
            text-align: center;
            line-height: @ballSize;
        }

        .point-text {
            padding-left: 10px;

            font-weight: bold;
            font-size: @app-font-size-point;

            align-self: center;
        }
    }
</style>